// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var _obj;
export var grey = (_obj = {}, _define_property(_obj, 25, '#FBFCFD'), _define_property(_obj, 50, '#F8F9FC'), _define_property(_obj, 100, '#F2F4F8'), _define_property(_obj, 200, '#E6E9F0'), _define_property(_obj, 300, '#D1D6E0'), _define_property(_obj, 400, '#A7AFBE'), _define_property(_obj, 500, '#68748D'), _define_property(_obj, 600, '#576175'), _define_property(_obj, 700, '#464E5D'), _define_property(_obj, 750, '#3B424E'), _define_property(_obj, 800, '#313742'), _define_property(_obj, 850, '#252931'), _define_property(_obj, 900, '#16181D'), _define_property(_obj, 950, '#0B0E13'), _obj);

//# sourceMappingURL=grey.js.map